import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const IconArrowHeadRight = props => (
  <SvgIcon {...props} viewBox="0 0 7.4000001 12">
    <polygon points="0 6 6 12 7.4 10.6 2.8 6 7.4 1.4 6 0" transform="matrix(-1,0,0,1,7.4,0)" />
  </SvgIcon>
);

export default IconArrowHeadRight;



// WEBPACK FOOTER //
// ./src/components/icons/IconArrowHeadRight.js